import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, BotIcon, FileTextIcon, BarChart3Icon } from 'lucide-react';
const roadmapSteps = [{
  week: 'Week 1',
  icon: ClipboardCheckIcon,
  title: 'Audit & ROI Blueprint',
  description: "We analyze your workflows and deliver a custom report showing exactly how much you'll save."
}, {
  week: 'Week 2',
  icon: BotIcon,
  title: 'Intake & Admin Automation',
  description: "We deploy your 24/7 AI receptionist and automate repetitive admin tasks. You'll see results this week."
}, {
  week: 'Week 3',
  icon: FileTextIcon,
  title: 'Drafting & Workflow Engine',
  description: 'We install your AI drafting tools and the automated deadline tracking system.'
}, {
  week: 'Week 4',
  icon: BarChart3Icon,
  title: 'Optimization, Training & Reporting',
  description: 'We fine-tune the system, train your team, and launch your real-time ROI dashboard.'
}];
export function HowItWorksSection() {
  return <section className="bg-off-white py-20 md:py-28" data-id="element-74">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-76">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-charcoal mb-6" data-id="element-77">
            Your Firm, Transformed in 30 Days.{' '}
            <span className="text-blue-accent" data-id="element-78">100% Done-For-You.</span>
          </h2>
        </motion.div>

        {/* Timeline */}
        <div className="relative max-w-3xl mx-auto" data-id="element-79">
          {/* Vertical Line */}
          <div className="absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-gold via-blue-accent to-gold transform md:-translate-x-1/2" data-id="element-80" />

          {roadmapSteps.map((step, index) => <motion.div key={step.week} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className={`relative flex items-start gap-6 mb-12 last:mb-0 ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`} data-id="element-81">
              {/* Timeline Node */}
              <div className="absolute left-8 md:left-1/2 w-4 h-4 bg-gold rounded-full transform -translate-x-1/2 mt-6 ring-4 ring-off-white z-10" data-id="element-82" />

              {/* Content Card */}
              <div className={`ml-16 md:ml-0 md:w-[calc(50%-2rem)] ${index % 2 === 0 ? 'md:pr-8' : 'md:pl-8'}`} data-id="element-83">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-charcoal/5" data-id="element-84">
                  <div className="flex items-center gap-4 mb-4" data-id="element-85">
                    <div className="w-12 h-12 bg-navy rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-86">
                      <step.icon className="w-6 h-6 text-gold" data-id="element-87" />
                    </div>
                    <div data-id="element-88">
                      <span className="text-gold font-semibold text-sm" data-id="element-89">
                        {step.week}
                      </span>
                      <h3 className="font-heading text-lg font-bold text-charcoal" data-id="element-90">
                        {step.title}
                      </h3>
                    </div>
                  </div>
                  <p className="text-charcoal/60 text-sm leading-relaxed" data-id="element-91">
                    {step.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}